import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const ProtectedRoute = ({
  children,
  requireAuth = false,
  requireOrderState = false,
}) => {
  const location = useLocation();

  // Redux states
  const { isAuthenticated } = useSelector((state) => state.auth || {});
  const { items } = useSelector((state) => state.cart || {});

  const reduxOrderState = useSelector((state) => state.ui.orderState);

  // Local state for orderState, initialized from Redux or sessionStorage
  const [orderState, setOrderState] = useState(() => {
    if (reduxOrderState?.isValid) return reduxOrderState;
    const saved = sessionStorage.getItem("orderState");
    return saved ? JSON.parse(saved) : null;
  });

  // 🔄 Sync orderState with Redux store and sessionStorage
  // 🔄 Keep orderState in sync with Redux and sessionStorage
  useEffect(() => {
    if (reduxOrderState?.isValid) {
      setOrderState(reduxOrderState);
      sessionStorage.setItem("orderState", JSON.stringify(reduxOrderState));
    }
  }, [reduxOrderState]);

  // Checkout guard
  if (location.pathname === "/checkout") {
    if (!items || items.length === 0) {
      return <Navigate to="/cart" replace />;
    }
  }

  // Order success guard
  if (location.pathname === "/order-success") {
    if (!(reduxOrderState?.isValid || orderState?.isValid)) {
      return <Navigate to="/" replace />;
    }
  }

  // Wishlist guard
  if (location.pathname === "/wishlist" && requireAuth && !isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;
};

export default ProtectedRoute;
